import apiClient, { unwrapData } from "./apiClient";

export async function getSettingsData(options = {}) {
  const response = await apiClient.get("/api/settings", options);
  return unwrapData(response);
}

export async function saveSettingsData(payload = {}, options = {}) {
  const response = await apiClient.patch("/api/settings", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function resetSettingsData(options = {}) {
  const response = await apiClient.post("/api/settings/reset", {
    ...options,
    body: {},
  });

  return unwrapData(response);
}
